import { SingleLineText } from './SingleLineText';
import { styled } from '@mui/material/styles';
import { Logo } from './Logo';

export type IconLabelItemProps = {
  emoji?: string;
  text: string;
  span?: string;
};

const StyledEmoji = styled(Logo)(
  () => `
  display: flex;
  padding: 0 2px 0 10px;
`,
);

const StyledText = styled(SingleLineText)(
  ({ theme }) => `
  color: ${theme.palette.neutral[50]};
  padding: 2px 2px 0 2px;
`,
);
const StyledSpan = styled(SingleLineText)(
  ({ theme }) => `
  color: ${theme.palette.neutral[30]};
  padding-top: 2px;
`,
);

const StyledContainer = styled('div')(
  ({ theme }) => `
  color: ${theme.palette.neutral[50]};
  display: flex;
  align-items: center;
`,
);

const IconLabelItem = ({ emoji, text, span }: IconLabelItemProps) => {
  return (
    <StyledContainer title={`${text}${span}`}>
      <StyledEmoji image={emoji} />
      <StyledText variant={'body2Medium'} text={text} />
      {span && <StyledSpan variant={'body2Medium'} text={span} />}
    </StyledContainer>
  );
};

export default IconLabelItem;
export { IconLabelItem };
